document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('MavivaCartForm');
  if (!form) return;

  const qtySelectors = form.querySelectorAll('.qty-selector:not(.is-locked)');
  const removeBtns = form.querySelectorAll('.js-remove-main');
  const emptyCartBtn = document.querySelector('.js-empty-cart');

  function submitCartUpdate(updates = null) {
    if (updates) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
      .then(() => window.location.reload())
      .catch(err => console.error(err));
    } else {
      let updateInput = form.querySelector('input[name="update"]');
      if (!updateInput) {
        updateInput = document.createElement('input');
        updateInput.type = 'hidden';
        updateInput.name = 'update';
        updateInput.value = '';
        form.appendChild(updateInput);
      }
      form.submit();
    }
  }

  if (emptyCartBtn) {
    emptyCartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (confirm("Sei sicuro di voler rimuovere tutto dal carrello?")) {
        document.body.style.opacity = '0.5';
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => window.location.reload())
          .catch(err => console.error(err));
      }
    });
  }

  qtySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('.qty-minus');
    const plusBtn = selector.querySelector('.qty-plus');
    const input = selector.querySelector('.qty-input');

    minusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      let currentValue = parseInt(input.value) || 0;
      if (currentValue > 0) {
        input.value = currentValue - 1;
        submitCartUpdate();
      }
    });

    plusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      let currentValue = parseInt(input.value) || 0;
      input.value = currentValue + 1;
      submitCartUpdate();
    });

    input.addEventListener('change', () => {
      submitCartUpdate();
    });
  });

  removeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const keyToRemove = btn.dataset.key;
      let updates = {};
      
      updates[keyToRemove] = 0;

      const supplementItems = form.querySelectorAll('.cart-item-supplement');
      supplementItems.forEach(supp => {
        const suppKey = supp.dataset.itemKey;
        if(suppKey) {
          updates[suppKey] = 0;
        }
      });

      document.body.style.opacity = '0.5'; 
      submitCartUpdate(updates);
    });
  });

});